/**
 * How long anything in the engine waits for one asset before carrying on
 * without it.
 *
 * There is ONE number because there is one question: a fetch that never
 * settles must not park the whole runtime on an idle event loop. Image's
 * texture-settle guard asked it first (a texture can fire neither `onLoad`
 * nor `onError` on NullEngine and with exotic loaders), and layout asks the
 * same question of a container whose child is still building. A second
 * constant would mean two different answers to it.
 *
 * It is a backstop, not a budget: nothing is cancelled when it expires. The
 * asset is still loading, still allowed to arrive, and whoever was waiting
 * re-runs when it does.
 */
export const ASSET_PATIENCE_MS = 10_000;
